// noinspection JSUnusedGlobalSymbols
import {Calendar} from '@fullcalendar/core'
import DayGridPlugin from '@fullcalendar/daygrid'
import InteractionPlugin from '@fullcalendar/interaction'
import FullCalendarJa from '@fullcalendar/core/locales/ja'
import Dayjs from 'dayjs'
import Helper from '../../../client/helper'
import Ui from '../../../client/ui'

export default class
{
	static init()
	{
		const language = Helper.language() === 'ja' ? FullCalendarJa : undefined

		const clicked = (event) =>
		{
			const date = Dayjs(event.date ? event.date : event.event.start)
			location.href = `/visit/?day=${date.format('YYYY-MM-DD')}`
		}

		const month = $('#calendar').data('month')

		const calendar = new Calendar($('#calendar')[0], {
			plugins             : [DayGridPlugin, InteractionPlugin],
			initialView         : 'dayGridMonth',
			locale              : language,
			height              : Ui.is_mobile() ? 750 : 550,
			showNonCurrentDates : false,
			firstDay            : 1,
			headerToolbar       : {
				left  : '',
				center: '',
				right : '',
			},
			eventContent        : function(info)
			{
				return {html: info.event.title}
			},
			eventSources        : ['/index/data'],
			initialDate         : month,
			editable            : false,
			eventBackgroundColor: '#0000',
			eventBorderColor    : '#0000',
			eventTextColor      : '#333',
			dateClick           : clicked,
			eventClick          : clicked,
		})

		calendar.render()
	}

	static news(id)
	{
		$(`#news_${id}`).slideToggle()
	}
}
